import { render, staticRenderFns } from "./ClientRetentionAcquisition.vue?vue&type=template&id=6b759a83"
import script from "./ClientRetentionAcquisition.vue?vue&type=script&lang=js"
export * from "./ClientRetentionAcquisition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports